import { Form } from "@amzn/aquila-feedback-web-assets";
import { TextButton } from "@amzn/storm-ui";
import type { FC } from "react";
import React, { useEffect, useState } from "react";
import { useStore } from "zustand";

import { useGetAllInsghtsTabReportIssueForm } from "../../hooks/aquila/reportIssue/useGetReportIssueForm/useGetAllInsghtsTabReportIssueForm";
import { useSubmitReportIssueForm } from "../../hooks/aquila/reportIssue/useSubmitReportIssueForm/useSubmitReportIssueForm";
import { authStore } from "../../store/auth";
import { reportIssueStore } from "../../store/reportIssue";
import { AquilaReportIssueTriggerType } from "../../types/aquila";
import { isSuccess } from "../../utils/api.utils";

const InternalReportIssue: FC = () => {
    const [aquilaConfig] = useStore(authStore, (state) => [
        state.settings.aquilaConfig,
    ]);
    const [activeModal, closeModal] = useStore(reportIssueStore, (state) => [
        state.activeModal,
        state.closeModal,
    ]);
    const [
        formConfig,
        formConfigAsyncStatus,
        getFormConfigAsyncAction,
        updateFormConfig,
    ] = useGetAllInsghtsTabReportIssueForm({
        reportIssueFormConfig:
            aquilaConfig.createInsightDeckPageReportIssueConfig,
    });
    const [isFeedbackFormOpen, setIsFeedbackFormOpen] = useState(false);
    const [, createFeedbackAsyncAction] = useSubmitReportIssueForm({
        reportIssueFormConfig:
            aquilaConfig.createInsightDeckPageReportIssueConfig,
        trigger: AquilaReportIssueTriggerType.ALL_INSIGHTS_CREATE_ON_DEMAND,
    });

    useEffect(() => {
        if (
            activeModal ===
            AquilaReportIssueTriggerType.CREATE_ON_DEMAND_INSIGHT
        ) {
            if (isSuccess(formConfigAsyncStatus) && formConfig) {
                setIsFeedbackFormOpen(true);
            } else {
                if (
                    aquilaConfig.createInsightDeckPageReportIssueConfig
                        ?.configId
                ) {
                    void getFormConfigAsyncAction.execute();
                }
            }
        }
    }, [activeModal, formConfigAsyncStatus, formConfig]);

    const handleOnSubmit = (formData) => {
        setIsFeedbackFormOpen(false);
        void createFeedbackAsyncAction.execute(formData);
        closeModal();
    };

    const handleOnCancel = () => {
        setIsFeedbackFormOpen(false);
        closeModal();
    };

    useEffect(() => {
        if (aquilaConfig.createInsightDeckPageReportIssueConfig?.configId) {
            void getFormConfigAsyncAction.execute();
        }
    }, []);

    return isSuccess(formConfigAsyncStatus) && formConfig ? (
        <>
            <TextButton onClick={() => setIsFeedbackFormOpen(true)}>
                Report an Issue
            </TextButton>
            {isFeedbackFormOpen && (
                <Form
                    {...formConfig}
                    configId={
                        aquilaConfig.createInsightDeckPageReportIssueConfig
                            .configId
                    }
                    onSubmit={handleOnSubmit}
                    onCancel={handleOnCancel}
                    onFieldChange={updateFormConfig}
                    isOpen={isFeedbackFormOpen}
                />
            )}
        </>
    ) : (
        <></>
    );
};

export const CreateInsightDeckReportIssue = React.memo(InternalReportIssue);
